import { render, staticRenderFns } from "./AccionModificarTipoVenta.vue?vue&type=template&id=24400e4e&scoped=true&"
import script from "./AccionModificarTipoVenta.vue?vue&type=script&lang=js&"
export * from "./AccionModificarTipoVenta.vue?vue&type=script&lang=js&"
import style0 from "./AccionModificarTipoVenta.vue?vue&type=style&index=0&id=24400e4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24400e4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24400e4e')) {
      api.createRecord('24400e4e', component.options)
    } else {
      api.reload('24400e4e', component.options)
    }
    module.hot.accept("./AccionModificarTipoVenta.vue?vue&type=template&id=24400e4e&scoped=true&", function () {
      api.rerender('24400e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/acciones/AccionModificarTipoVenta.vue"
export default component.exports